export enum UapiStatus {
  PENDING = "pending",
  LINKED = "linked",
  ERROR_STARTING_AUTH = "Error starting authentication",
  ERROR_CHECKING_AUTH = "Error checking auth status",
  ERROR_CHECKING_AUTH_STATUS = "Error checking authentication status",
}
